import { MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS } from "@editor/modules/media-lib/constants";
import { cn } from "@lib/cn";
import { useState } from "react";
import { Blurhash } from "react-blurhash";
import type { IMediaFile } from "@/shared/types";

interface IProps {
  fileData: IMediaFile;
  isSelected?: boolean;
}

export const MediaLibFileImage = ({ fileData, isSelected }: IProps) => {
  const [isLoading, setIsLoading] = useState(true);

  let metaAspectRatio: number | undefined;
  if (
    fileData.metadata &&
    fileData.metadata.width &&
    fileData.metadata.height
  ) {
    metaAspectRatio = fileData.metadata.height / fileData.metadata.width;
  }

  return (
    <div
      className="tw-relative tw-rounded tw-bg-blue-50"
      style={{
        minHeight:
          isLoading && !metaAspectRatio
            ? MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0]
            : undefined,
      }}
    >
      <div
        style={{
          paddingTop: metaAspectRatio ? `${metaAspectRatio * 100}%` : undefined,
        }}
      >
        {isLoading && (
          <div className="tw-absolute tw-left-0 tw-top-0 tw-size-full tw-animate-skeleton-loading tw-rounded tw-bg-blue-50" />
        )}

        {fileData.metadata?.imageBlurhash && isLoading && (
          <div className="tw-absolute tw-left-0 tw-top-0 tw-size-full tw-overflow-hidden tw-rounded">
            <Blurhash
              hash={fileData.metadata.imageBlurhash}
              className="!tw-size-full"
            />
          </div>
        )}

        <img
          width={fileData.metadata?.width}
          height={fileData.metadata?.height}
          key={fileData._id}
          onLoad={() => {
            setIsLoading(false);
          }}
          onError={() => {
            setIsLoading(false);
          }}
          alt=""
          loading="lazy"
          src={fileData.url}
          style={{
            minHeight: isLoading
              ? MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0]
              : undefined,
          }}
          className={cn(
            metaAspectRatio ? "tw-absolute tw-left-0 tw-top-0" : "tw-relative",
            "tw-z-10 tw-size-full tw-min-h-8 tw-cursor-pointer tw-rounded tw-object-contain",
            "tw-outline tw-outline-1 -tw-outline-offset-1",
            !isLoading &&
              "tw-transition-[outline-color] hover:tw-outline-offset-1 hover:tw-outline-primary",
            isSelected && !isLoading
              ? "tw-outline-offset-1 tw-outline-primary"
              : "tw-outline-blue/20",
          )}
        />
      </div>
    </div>
  );
};
